import { useProductHeroContentByCriteriaQuery } from '@graphql/generated';
import { useCatalogCurationHeroTelemetry } from './CatalogCurationHero.telemetry';
import { useShopStorefrontContext } from '@apps/registry/common/components/Catalog/components/ShopStorefrontProvider';
import type { ShopRootExpertsExploreCurationClicked } from '@apps/registry/common/components/Catalog/Catalog.telemetry.types';
import { useEventCallback } from '@shared/utils/hooks/useEventCallback';
import type { CatalogCurationHeroProps } from './CatalogCurationHero';

export const useCatalogCurationHeroController = (props: CatalogCurationHeroProps) => {
  const { currentStorefront, config } = useShopStorefrontContext();
  const { data, loading } = useProductHeroContentByCriteriaQuery({ batchMode: 'fast', variables: { criteria: { storefront: currentStorefront } }, skip: props.skipServerHeros });
  const curations = data?.productHeroContentByCriteria;

  const curationsAndStaticHero = [
    ...(props.skipStaticHero ? [] : [config.staticHeroAtStart]),
    ...(curations && curations.length > 0 ? curations : props.skipServerHeros ? [] : [config.fallbackHero]),
  ];

  const { trackExploreCurationClicked, trackBillboardWatchCurationVideoCtaClick } = useCatalogCurationHeroTelemetry(curationsAndStaticHero);

  const handleOnViewCollectionClick = useEventCallback((e, id) => {
    props.onViewCollectionClick?.(e, id);
    const { isvideoplaying, method } = e.currentTarget.dataset;
    trackExploreCurationClicked(id, method as ShopRootExpertsExploreCurationClicked['method'], isvideoplaying === 'true');
  });

  const handleOnOpenVideoPlayer = useEventCallback((curationId: string) => trackBillboardWatchCurationVideoCtaClick(curationId));

  return {
    loading,
    curations: curationsAndStaticHero,
    handleOnViewCollectionClick,
    handleOnOpenVideoPlayer,
  };
};
